import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import Widget from 'common/components/Widget';
import DriversLeaderboardTable from 'modules/statistics/modules/driver-behavior/components/DriversLeaderboardTable';
import { BaseDriverBehaviorModel } from 'common/model/statistics';

interface Props extends WithTranslation {
    loading: boolean;
    data: BaseDriverBehaviorModel[];
    onClick?: () => void;
}

function TopDriversWidget(props: Props) {
    return (
        <Widget
            loading={props.loading}
            title={props.t('CompanyProfileDashboard.topDrivers')}
            styleName="prize"
            content={
                props.data.length === 0 ? (
                    <div className="widget-empty">{props.t('utils.empty')}</div>
                ) : (
                    <DriversLeaderboardTable data={props.data ?? []} loading={false} showHeader={false} />
                )
            }
            onClick={props.onClick}
        />
    );
}

export default withTranslation()(TopDriversWidget);
